import { DatePicker, Form, Input, InputNumber } from "antd";
import { formatMoney } from "../../../utils/formatUtils";
import { RATE_MODE } from "../utils/rateMode";

function positiveRateValidator(message = "Ханш 0-ээс их байх ёстой") {
  return (_, value) => {
    const numeric = Number(value);

    if (!numeric || numeric <= 0) {
      return Promise.reject(new Error(message));
    }

    return Promise.resolve();
  };
}

export default function TransactionDetailsSection({
  isManual,
  isTransfer,
  selectedAccount,
  receiverAccount,
  rateMode,
  senderCurrency,
  receiverCurrency,
  isAmountExceedingWallet,
  senderWalletBalance,
}) {
  const showRateSection = isManual
    ? !!selectedAccount
    : !!receiverAccount || rateMode?.key === RATE_MODE.INVALID_MANUAL_CURRENCY;

  return (
    <div className="mb-5 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <div className="mb-4">
        <div className="text-base font-semibold text-slate-800">
          Гүйлгээний мэдээлэл
        </div>
        <div className="text-sm text-slate-500">
          Гүйлгээний мэдээллээ оруулна уу
        </div>
      </div>

        <Form.Item
          label={<span className="font-medium text-slate-700">Огноо, цаг</span>}
          name="transactionDate"
          rules={[{ required: true, message: "Огноо, цаг оруулна уу" }]}
          className="md:col-span-3"
        >
          <DatePicker
            showTime
            size="large"
            className="w-full"
            format="YYYY-MM-DD HH:mm:ss"
          />
        </Form.Item>

        {showRateSection && (
          <div className="mt-6 border-t border-slate-200 pt-5">
            {rateMode?.key === RATE_MODE.INVALID_MANUAL_CURRENCY && (
              <div className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
                Manual income үед илгээгч болон хүлээн авагч account ижил валюттай байх ёстой.
              </div>
            )}

            {(rateMode?.key === RATE_MODE.MANUAL_MNT_TO_MNT ||
              rateMode?.key === RATE_MODE.TRANSFER_MNT_TO_MNT) && (
              <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                <Form.Item
                  label={<span className="font-medium text-slate-700">Илгээх ханш</span>}
                  name="senderRate"
                >
                  <InputNumber size="large" className="w-full" disabled />
                </Form.Item>

                <Form.Item
                  label={<span className="font-medium text-slate-700">Хүлээн авах ханш</span>}
                  name="receiverRate"
                >
                  <InputNumber size="large" className="w-full" disabled />
                </Form.Item>
              </div>
            )}

            {rateMode?.sharedInput && (
              <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
                <Form.Item
                  label={<span className="font-medium text-slate-700">Ханш</span>}
                  name="sharedRate"
                  rules={[
                    { required: true, message: "Ханш оруулна уу" },
                    { validator: positiveRateValidator() },
                  ]}
                >
                  <InputNumber
                    size="large"
                    className="w-full"
                    min={0.000001}
                    precision={6}
                    placeholder="Ханш оруулна уу"
                  />
                </Form.Item>

                <Form.Item
                  label={
                    <span className="font-medium text-slate-700">
                      Илгээх ханш ({senderCurrency || "-"} → MNT)
                    </span>
                  }
                  name="senderRate"
                >
                  <InputNumber size="large" className="w-full" disabled />
                </Form.Item>

                <Form.Item
                  label={
                    <span className="font-medium text-slate-700">
                      Хүлээн авах ханш ({receiverCurrency || "-"} → MNT)
                    </span>
                  }
                  name="receiverRate"
                >
                  <InputNumber size="large" className="w-full" disabled />
                </Form.Item>
              </div>
            )}

            {!rateMode?.sharedInput &&
              rateMode?.key !== RATE_MODE.MANUAL_MNT_TO_MNT &&
              rateMode?.key !== RATE_MODE.TRANSFER_MNT_TO_MNT &&
              rateMode?.key !== RATE_MODE.INVALID_MANUAL_CURRENCY &&
              rateMode?.key !== RATE_MODE.NONE && (
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <Form.Item
                    label={
                      <span className="font-medium text-slate-700">
                        Илгээх ханш ({senderCurrency || "-"} → MNT)
                      </span>
                    }
                    name="senderRate"
                    rules={
                      rateMode?.requireSenderRate
                        ? [
                            { required: true, message: "Sender ханш оруулна уу" },
                            { validator: positiveRateValidator() },
                          ]
                        : []
                    }
                  >
                    <InputNumber
                      size="large"
                      className="w-full"
                      min={0.000001}
                      precision={6}
                      disabled={rateMode?.senderFixed}
                      placeholder="Sender ханш"
                    />
                  </Form.Item>

                  <Form.Item
                    label={
                      <span className="font-medium text-slate-700">
                        Хүлээн авах ханш ({receiverCurrency || "-"} → MNT)
                      </span>
                    }
                    name="receiverRate"
                    rules={
                      rateMode?.requireReceiverRate
                        ? [
                            { required: true, message: "Receiver ханш оруулна уу" },
                            { validator: positiveRateValidator() },
                          ]
                        : []
                    }
                  >
                    <InputNumber
                      size="large"
                      className="w-full"
                      min={0.000001}
                      precision={6}
                      disabled={rateMode?.receiverFixed}
                      placeholder="Receiver ханш"
                    />
                  </Form.Item>
                </div>
              )}
          </div>
        )}

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <Form.Item
          label={
            <span className="font-medium text-slate-700">
              Дүн ({selectedAccount?.currency || "-"})
            </span>
          }
          name="amount"
          validateStatus={isAmountExceedingWallet ? "error" : ""}
          help={
            isAmountExceedingWallet
              ? `Нийт шилжүүлэх дүн хэтэрсэн байна. Боломжит дээд дүн: ${formatMoney(
                  senderWalletBalance,
                  selectedAccount?.currency
                )}`
              : null
          }
          rules={[
            { required: true, message: "Дүн оруулна уу" },
            () => ({
              validator(_, value) {
                const numeric = Number(value || 0);

                if (!numeric || numeric <= 0) {
                  return Promise.resolve();
                }

                if (isTransfer && numeric > senderWalletBalance) {
                  return Promise.reject(
                    new Error("Шилжүүлэх дүн илгээгчийн wallet үлдэгдлээс их байна")
                  );
                }

                return Promise.resolve();
              },
            }),
          ]}
        >
          <InputNumber
            size="large"
            className={`w-full ${isAmountExceedingWallet ? "border-red-500" : ""}`}
            min={0.01}
            precision={2}
            placeholder="Дүн оруулна уу"
            status={isAmountExceedingWallet ? "error" : ""}
          />
        </Form.Item>

        <Form.Item
          label={<span className="font-medium text-slate-700">Шимтгэл</span>}
          name="fee"
          validateStatus={isAmountExceedingWallet ? "error" : ""}
          help={
            isAmountExceedingWallet
              ? `Нийт шилжүүлэх дүн хэтэрсэн байна. Боломжит дээд дүн: ${formatMoney(
                  senderWalletBalance,
                  selectedAccount?.currency
                )}`
              : null
          }
          tooltip="Шимтгэл нь тусдаа бүртгэгдэнэ. Шилжүүлэх дүнгээс хасагдахгүй."
        >
          <InputNumber
            size="large"
            className="w-full"
            min={0}
            precision={2}
            placeholder="Шимтгэлийн дүн оруулна уу"
          />
        </Form.Item>
      </div>

      <Form.Item
        className="mt-4"
        label={<span className="font-medium text-slate-700">Тайлбар</span>}
        name="description"
        rules={[
          { required: true, message: "Тайлбар оруулна уу" },
        ]}
      >
        <Input.TextArea
          rows={4}
          placeholder="Тайлбар, тэмдэглэл эсвэл лавлах мэдээлэл оруулна уу"
          className="rounded-xl"
        />
      </Form.Item>
    </div>
  );
}